import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';
import _ from 'lodash';

export default {
    errorOrGraphQLMessage,
    GraphQLStackTrace,
    renderGraphQLStatusOrNull,
    defaultOptions,
    getValueAtPathOfClosestParent
};

export function errorOrGraphQLMessage(error) {
    let message = error.message;
    if (error.graphQLErrors && error.graphQLErrors.length) {
        message = error.graphQLErrors[0].message;
    }
    return message;
}

export function GraphQLStackTrace(error) {
    let stack = errorOrGraphQLMessage(error);
    if (error.graphQLErrors && error.graphQLErrors.length && error.graphQLErrors[0].stack) {
        stack = error.graphQLErrors[0].stack;
    }
    return stack;
}

export function renderGraphQLStatusOrNull(graphQLDataArray) {
    if (!Array.isArray(graphQLDataArray)) {
        graphQLDataArray = [graphQLDataArray];
    }
    if (_.some(graphQLDataArray, 'loading')) {
        return <CircularProgress className="activityIndicator"/>;
    } else if (_.some(graphQLDataArray, 'error')) {
        return <pre>{GraphQLStackTrace(_.find(graphQLDataArray, 'error').error)}</pre>;
    } else {
        return null;
    }
}

export function defaultOptions(defaults, options, transforms) {
    let transformedOptions = {};
    if (transforms) {
        _.forEach(transforms, (transform, path) => {
            if (_.has(options, path)) {
                _.set(transformedOptions, path, transform(_.get(options, path)));
            }
        });
    }
    return _.chain({}).merge(defaults, options, transformedOptions).pick(_.keys(defaults)).value();
}

export function getValueAtPathOfClosestParent(element, path, defaultValue) {
    while (element && !_.hasIn(element, path)) {
        element = element.parentNode;
    }
    return _.get(element, path, defaultValue);
}



// WEBPACK FOOTER //
// ./src/utils/utils.js